import { FaturaItem } from "./fatura-item.model";
import { FaturaParcela } from "./fatura-parcela.model";

export class Fatura {

    faturaId: number = 0;

    faturaTipo: number = 0;

    faturaStatus: number = 0;

    faturaTipoDocumento: number = 0;

    descricao: string = '';

    dataCriacao: Date = new Date();


    valorDesconto: number = 0;

    valorBruto: number = 0;

    valorLiquido: number = 0;

    dataPrimeiroPagamento: Date = new Date();

    dataUltimoPagamento: Date = new Date();

    parceiroId: number = 0; //Se tipoConta for 0 então é cliente, se tpConta for 1 então é fornecedor

    tipoPagamento: number = 0;

    contaId: number = 0;

    contratoId: number | null = null;

    grupoContaId: number | null = null;

    caixaId: number | null = null;

    empresaId: number = null;

    nfeId: number | null = null;

    valorSemRetencoes: number = 0;


    saguiClienteId: number = 0;

    centroCustoId: number | null = null;

    nfseId: number | null = null;

    faturaItens: FaturaItem[] = [];

    faturaParcelas: FaturaParcela[] = [];

    valorTotalBruto: number = this.valorBruto;

    documentoFiscal: number = 1;

    mesAnoReferencia: Date = new Date();

    statusIntegracaoSOC: number = 0;

    servicoListaId: any ="-1";

    faturarParaOutraEmpresa: boolean = false;

    empresaFinanceiroId: number | null = null;

}


export enum FaturaTipoDocumento {
    VendaProduto,
    VendaServico,
    CompraProduto,
    CompraServico,
    DevolucaoVendaProduto,
    DevolucaoVendaServico,
    DevolucaoCompraProduto,
    DevolucaoCompraServico  
}

export enum FaturaTipo {
    Venda,
    Compra
}

/** Espelha VirescoCore.Domain.Enums.FaturaStatus do back. */
export enum FaturaStatus {
    Aberta = 0,
    Faturada = 1,
    Cancelada = 99,
    Faturando = 100,
    ErroAoFaturar = 101,
    ErroAoFaturarNFse = 102,
    ErroAoFaturarBoleto = 103,
    Cancelando = 104,
    ErroAoCancelar = 105
}